import { useQuery } from '@tanstack/react-query';
import useProductId from '@/app/[locale]/new/(products)/[productType]/[...slug]/components/hooks/useProductId';
import { useCurrency } from '@/contexts/CurrencyContext';
export default function useGetProductInclusions() {
    const { selectedCurrency } = useCurrency();
    const productId = useProductId();
    return useQuery({
        queryKey: [`/api/adventure/v2/activities/${productId}/inclusions/`, {}, selectedCurrency],
        enabled: Boolean(productId) && Boolean(selectedCurrency),
    });
}
